module.exports = __webpack_public_path__ + "src/assets/img/close.861f15bc.png";